import { useState } from 'react'
import Section from './Section/Section'
import _ from 'lodash'

export type AccordionItem = {
  key: string
  title: React.ReactNode | string
  content: React.ReactNode | string
}

type Props = {
  items: AccordionItem[]
  className?: string
  initOpenIndex?: string
  invert?: boolean
}

const Accordion: React.FC<Props> = ({ items, className = '', initOpenIndex, invert = false }) => {
  const [openIndex, setOpenIndex] = useState<string>(!_.isUndefined(initOpenIndex) ? initOpenIndex : null)

  const toggle = (index: string) => () => {
    setOpenIndex(openIndex === index ? null : index)
    if (openIndex !== index) {
      const content = document.getElementById(index)
      if (content) {
        setTimeout(() => {
          const yOffset = -100 // 50px offset
          const y = content.getBoundingClientRect().top + window.scrollY + yOffset
          window.scrollTo({ top: y, behavior: 'smooth' })
        }, 300)
      }
    }
  }

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {items.map(({ title, content, key }) => (
        <Section invert={invert} id={key} key={key} open={openIndex === key} title={title} clickedCallback={toggle(key)}>
          {content}
        </Section>
      ))}
    </div>
  )
}

export default Accordion
